import React, { createContext, useState } from "react";
import { useNavigate } from "react-router-dom";

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  // const [selectedCategory, setSelectedCategory] = useState();
  const [cartItems, setCartItems] = useState([]);
  // const [data, setData] = useState([]);
const [authToken, setAuthToken] = useState(() => {
  return localStorage.getItem("authToken") || "";
});
  // const [loggedInTeacher, setLoggedInTeacher] = useState();
  const [loggedInTeacher, setLoggedInTeacher] = useState(() => {
  const teacher = localStorage.getItem("teacher");
  return teacher ? JSON.parse(teacher) : null;
});
const [loggedInStudent, setLoggedInStudent] = useState(() => {
  const savedStudent = localStorage.getItem("student");

  return savedStudent
    ? JSON.parse(savedStudent)
    : null;
});
  // const [loggedInStudent, setLoggedInStudent] = useState();
  const [loggedInAdmin, setLoggedInAdmin] = useState();
  const [selectedCourseForAttendance, setSelectedCourseForAttendance] = useState(null);


  const [baseUrl, setBaseUrl] = useState("https://ggcw.btsportfolio2026.com/backend/public/api");
  const [baseUrlForFiles, setBaseUrlForFiles] = useState(
    "https://ggcw.btsportfolio2026.com/backend/public/storage",
  );

  // const [baseUrl, setBaseUrl] = useState("http://127.0.0.1:8000/api");
  // const [baseUrlForFiles, setBaseUrlForFiles] = useState(
  //   "http://127.0.0.1:8000/storage",
  // );
  const navigate = useNavigate();

  

  const emailRegex = new RegExp(/^[A-Za-z0-9]{5,}@[a-z0-9.-]{3,}\.[a-z]{2,}$/);
  const passwordRegex = new RegExp(/^[A-Za-z0-9@#$%^&*!]{6,}$/);
  const fullnameRegex = new RegExp(/^[A-Za-z]{3,}$/);
  const programRegex = new RegExp(/^[A-Za-z]{3,}$/);
  const semesterRegex = new RegExp(/^[A-Za-z 0-9]{3,}$/);
  const rollnoRegex = new RegExp(/^[A-Za-z0-9]{1,}$/);
  //   const phoneRegex = new RegExp(/^[0-9+] {11,}$/);
  //   const departmentRegex = (/^[A-Z][A-Za-z]{2,}$/);
  //   const hodRegex = (/^[A-Z][A-Za-z]{2,}$/);
  //  const programCode= new RegExp(/^[A-Za-z 0-9]{3,}$/);
  const regExpChecker = (type, inp) => {
    switch (type) {
      case "email":
        if (!emailRegex.test(inp)) {
          return "Invalid Email";
        }
        break;
      case "password":
        if (!passwordRegex.test(inp)) {
          return "Password must be at least 6 characters";
        }
        break;
      case "fullname":
        if (!fullnameRegex.test(inp)) {
          return "fullname must be at least 3 characters";
        }
        break;
      case "program":
        if (!programRegex.test(inp)) {
          return "program must be at least 3 characters";
        }
        break;
      case "semester":
        if (!semesterRegex.test(inp)) {
          return "semester must be at least 3 characters";
        }
        break;
      case "rollno":
        if (!rollnoRegex.test(inp)) {
          return "rollno must be at least 2 characters";
        }
        break;
      default:
        // Agar koi aur type aya toh koi error nahi
        return "";
    }
    // Agar sab sahi ho toh empty string return karo
    return "";
  };
 

  //     const [selectedCategory,setSelectedCategory] = useState();
  //     const [cartItems,setCartItems] = useState([]);
  //     const [data,setData] = useState([]);
  //     const [authToken,setAuthToken]=useState("");
  //     const [loggedInAdmin,setLoggedInAdmin]=useState();

  //     const [baseUrl,setBaseUrl] = useState("http://127.0.0.1:8000/api");
  //     const [baseUrlForFiles,setBaseUrlForFiles] = useState("http://127.0.0.1:8000/storage");
  // const navigate = useNavigate();

  //     const moonData=(sd)=>{
  //         setData();
  //     }

  //     const storeSingleCart = (ssc)=>{
  //         setCartItems(oldCart => [...oldCart,ssc]);
  //     }

  //     const emailRegex = new RegExp(/^[A-Za-z0-9]{5,}@[a-z0-9.-]{3,}\.[a-z]{2,}$/);
  //     const passwordRegex = new RegExp(/^[A-Za-z0-9@#$%^&*!]{6,}$/);
  //     const fullnameRegex = new RegExp(/^[A-Za-z]{3,} $/);
  //      const programRegex = new RegExp(/^[A-Za-z]{3,} $/);
  //     const semesterRegex = new RegExp(/^[A-Za-z 0-9]{3,} $/);
  //     const rollnoRegex = new RegExp(/^[A-Za-z0-9]{1,} $/);
  //     const phoneRegex =new RegExp(/^[0-9+] {11,}$/);

  //     const regExpChecker = (type, inp) => {
  //         switch (type) {
  //             case "email":
  //                 if (!emailRegex.test(inp)) {
  //                     return "Invalid Email";
  //                 }
  //                 break;
  //             case "password":
  //                 if (!passwordRegex.test(inp)) {
  //                     return "Password must be at least 6 characters";
  //                 }
  //                 break;
  //                  case "fullname":
  //                 if (!fullnameRegex.test(inp)) {
  //                     return "fullname must be at least 3 characters";
  //                 }
  //                 break;
  //                  case "program":
  //                 if (!programRegex.test(inp)) {
  //                     return "program must be at least 3 characters";
  //                 }
  //                 break;
  //                  case "semester":
  //                 if (!semesterRegex.test(inp)) {
  //                     return "semester must be at least 3 characters";
  //                 }
  //                 break;
  //                  case "rollno":
  //                 if (!rollnoRegex.test(inp)) {
  //                     return "rollno must be at least 3 characters";
  //                 }
  //                 break;
  //                 case"phone":
  //                 if(!phoneRegex.test(inp)){
  //                     return"phone no must be at least 11 character";
  //                 }
  //                 break;
  //             default:
  //                 // Agar koi aur type aya toh koi error nahi
  //                 return "";
  //         }
  //         break;
  //       case "phone":
  //         if (!phoneRegex.test(inp)) {
  //           return "phone no must be at least 11 character";
  //         }
  //         break;
  //       case "department":
  //         if (!departmentRegex.test(inp)) {
  //           return "Department name must have Alphabet";
  //         }
  //         break;
  //       case "hod":
  //         if (!hodRegex.test(inp)) {
  //           return "HOD name must have Alphabet";
  //         }
  //         break;
  //         case "programCode":
  //         if (!hodRegex.test(inp)) {
  //           return "programme name must have Alphabet and character";
  //         }
  //         break;
  //       default:
  //         // Agar koi aur type aya toh koi error nahi
  //         return "";
  //     }
  //     // Agar sab sahi ho toh empty string return karo
  //     return "";
  //   };

  return (
    <AppContext.Provider
      value={{
        // selectedCategory,
        authToken,
        cartItems,
        baseUrl,
        baseUrlForFiles,
        loggedInStudent,
        loggedInTeacher,
        loggedInAdmin,
        selectedCourseForAttendance,
        setAuthToken,
        // moonData,
        navigate,
        setLoggedInStudent,
        // storeSingleCart,
        setLoggedInTeacher,
        regExpChecker,
        setLoggedInAdmin,
        setSelectedCourseForAttendance
        // storeSelectedCategory
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

